import { setLocalStorage } from "../localStorage";

export function terminateSession(): void {
  setLocalStorage("token", undefined);
}
